<template>
  <div class="container mt-5 mb-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card shadow-lg p-4">
          <h2 class="text-center mb-4 text-primary">
            <i class="fa fa-envelope me-2"></i>{{ $t("forgot.title") }}
          </h2>

          <div v-if="successMessage" class="alert alert-success">
            <i class="fa fa-check-circle me-2"></i>{{ successMessage }}
          </div>
          <div v-if="errorMessage" class="alert alert-danger">
            <i class="fa fa-exclamation-circle me-2"></i>{{ errorMessage }}
          </div>

          <form @submit.prevent="requestReset">
            <div class="mb-3">
              <label for="email" class="form-label">
                <i class="fa fa-envelope me-2"></i>{{ $t("forgot.email") }}
              </label>
              <input
                type="email"
                id="email"
                class="form-control"
                v-model="email"
                required
                :placeholder="$t('forgot.placeholder')"
              />
            </div>

            <button type="submit" class="btn btn-primary w-100" :disabled="loading">
              <i class="fa fa-paper-plane me-2"></i>{{ loading ? $t("forgot.loading") : $t("forgot.button") }}
            </button>
          </form>

          <div class="text-center mt-3">
            <router-link to="/login" class="back-link">
              <i class="fa fa-arrow-left me-1"></i>{{ $t("forgot.back") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  border-radius: 10px;
  background: #ffffff;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
h2 {
  font-size: 1.8rem;
  font-weight: bold;
}
.form-control {
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 12px;
}
.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
.btn-primary {
  background-color: #007bff;
  border: none;
  padding: 12px;
  font-size: 1.1rem;
  border-radius: 8px;
  transition: background-color 0.3s;
}
.btn-primary:hover {
  background-color: #0056b3;
}
.back-link {
  color: #007bff;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s;
}
.back-link:hover {
  color: #0056b3;
}
.alert {
  font-size: 0.9rem;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
}
</style>

<script>
import axios from "axios";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      successMessage: "",
      errorMessage: "",
      loading: false,
    };
  },
  methods: {
    async requestReset() {
      if (!this.email.includes("@")) {
        this.errorMessage = this.$t("forgot.invalid");
        return;
      }

      this.errorMessage = "";
      this.successMessage = "";
      this.loading = true;

      try {
        await axios.post("https://api.feribot-eurobac.ro/client/api/forgot-password/", {
          email: this.email.trim(),
        });

        this.successMessage = this.$t("forgot.success");
        this.loading = false;

        localStorage.setItem("reset_email", this.email.trim());

        setTimeout(() => {
          this.$router.push("/resetare-parola");
        }, 2000);
      } catch (error) {
        this.errorMessage = error.response?.data?.error || this.$t("forgot.error");
        this.loading = false;
      }
    },
  },
};
</script>
